// extracted by mini-css-extract-plugin
export default {"home-container":"Home_home-container__fBKwh","title":"Home_title__T7u0H","games-title":"Home_games-title__Asatm"};